import { type CSSProperties } from 'react';

import { type DiscountBadge } from '../../../shared/types';

function getDiscountCodeCampaignBadgeStyle(discountBadge: DiscountBadge): CSSProperties {
    const hasGradient = Boolean(discountBadge.secondaryColor);

    return {
        background: hasGradient
            ? `linear-gradient(90deg, ${discountBadge.primaryColor} 0%, ${discountBadge.secondaryColor} 100%)`
            : discountBadge.primaryColor,
        color: discountBadge.textColor,
    };
}

export { getDiscountCodeCampaignBadgeStyle };
